import { Clock, Heart, ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { type RecipeData, categoryLabels } from '@/data/mockData';

interface RecipeCardProps {
  recipe: RecipeData;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  onSelect: () => void;
}

const RecipeCard = ({ recipe, isFavorite, onToggleFavorite, onSelect }: RecipeCardProps) => (
  <div
    onClick={onSelect}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => { if (e.key === 'Enter') onSelect(); }}
    className="text-left bg-card rounded-xl p-3 shadow-card hover:shadow-soft transition-shadow w-full cursor-pointer"
  >
    <div className="flex items-start justify-between mb-0.5">
      <h3 className="text-xs font-heading font-semibold flex-1 pr-2 leading-snug">{recipe.title}</h3>
      <button
        onClick={(e) => { e.stopPropagation(); onToggleFavorite(); }}
        className="p-0.5 flex-shrink-0"
      >
        <Heart className={cn("h-3.5 w-3.5", isFavorite ? "fill-accent text-accent" : "text-muted-foreground")} />
      </button>
    </div>

    <p className="text-[10px] text-muted-foreground flex items-center gap-1.5 mb-1">
      <span>{categoryLabels[recipe.category]}</span>
      <span>•</span>
      <span className="flex items-center gap-0.5"><Clock className="h-2.5 w-2.5" />{recipe.prepTime}</span>
    </p>

    <p className="text-[11px] text-muted-foreground line-clamp-2 mb-1.5">{recipe.description}</p>

    <div className="flex items-center gap-1 flex-wrap mb-1">
      <span className="text-[9px] bg-secondary text-secondary-foreground px-1.5 py-px rounded-full font-medium">
        {recipe.benefitTag}
      </span>
      <span className="text-[9px] bg-muted text-muted-foreground px-1.5 py-px rounded-full">
        {recipe.contextTag}
      </span>
    </div>

    <div className="flex items-center justify-between">
      <p className="text-[9px] text-muted-foreground italic truncate pr-2">{recipe.usageContext}</p>
      <ArrowRight className="h-3 w-3 text-primary flex-shrink-0" />
    </div>
  </div>
);

export default RecipeCard;
